<template>
  <div>
    <ItemListTable :fixedItemTypeId="1" />
  </div>
</template>

<script>
import ItemListTable from "@/modules/item/components/ItemListTable.vue";

export default {
  name: "ProductsList",
  data() {
    return {};
  },
  components: {
    ItemListTable
  }
};
</script>
